import { createSelector } from 'reselect';

const getList = state => {
    if (state.deviceTypes.get('list')) {
        return state.deviceTypes.getIn(['list', 'data']);
    }
    return undefined;
};

const getDeviceTypesAreLoading = state => state.deviceTypes.getIn(['list', 'isLoading']);

/* ====================== SELECTORS ======================== */
export const getDeviceTypesList = createSelector([getList], list => list && list.toJS());

export const getAllDeviceTypesAreLoading = createSelector(
    [getDeviceTypesAreLoading],
    isLoading => isLoading
);
